<template>
  <div class="card-item card-item-battery">
    <icon-battery class="icon" v-ifield-b-tooltip="iconTooltipText" />
    <span
      ref="truncTarget"
      class="text ellipsis"
      v-ifield-b-tooltip="tooltipOption"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
import { toRefs } from 'vue'
import IconBattery from '@/assets/ifield/ic_battery.svg?component'
import { useIsTruncated } from '@/composables/UseIsTruncated'
import { useUserStatusAdditionalItemBattery } from '@/composables/user/additionalItem'

export default {
  name: 'AppCardMemberItemBattery',
  components: {
    IconBattery,
  },
  inheritAttrs: false,
  props: {
    /**
     * バッテリー値
     */
    value: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const { value } = toRefs(props)
    const { truncTarget, isTruncated } = useIsTruncated()
    const { text } = useUserStatusAdditionalItemBattery({ value })
    return { truncTarget, isTruncated, text }
  },
  computed: {
    /**
     * アイコン部ツールチップテキスト
     * @type {string}
     */
    iconTooltipText: function () {
      return `${this.$t('appCardMemberItemBattery.batteryLevel')} : ${
        this.text
      }`
    },
    /**
     * ツールチップオプション
     * @type {Object}
     */
    tooltipOption: function () {
      return {
        title: this.text,
        disabled: !this.isTruncated,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/member/card-member-item';
</style>
